export default __webpack_public_path__ + "static/media/portfolio1.5ca87115.jpg";